<template>
  <v-row>
    <v-col cols="12">
      <BaseFilter
        v-model="search"
        :textPlaceholder="'Buscar'"
        v-bind="defaultConfigs"
        @search="searchByFilter"
        v-on:keyup="searchByFilterClickEnter"
      />
    </v-col>
    <v-col cols="12">
      <BaseDataTable
        :headers="header"
        :items="itemsCriticism.items"
        no-data-text="Nenhuma Crítica foi encontrada"
        :options.sync="options"
        :server-items-length="itemsCriticism.total"
        @click:row="redirectToCriticism"
        class="criticism-table"
      >
        <template v-slot:[`item.cotacao.numero`]="{ item }">
          <div :class="borderColor(item.cotacao.status)">
            <div class="quotation-table__padding">
              {{ item.cotacao.numero }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.cotacao.status`]="{ item }">
          {{ item.cotacao.status.nome }}
        </template>
        <template v-slot:[`item.data_criacao`]="{ item }">
          {{ formatDate(item.data_criacao) }}
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { differenceInDays } from "date-fns";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
const TABLE_HEADERS = [
  { text: "N° da Solicitação", value: "cotacao.numero", sortable: true },
  {
    text: "Tomador Matriz/Filial",
    value: "cotacao.tomador.nome_fantasia",
    sortable: true
  },
  { text: "Segurado", value: "cotacao.segurado.nome", sortable: true },
  { text: "Status", value: "cotacao.status", sortable: true },
  { text: "Aguardando retorno", value: "data_criacao", sortable: true }
];
const COLOR_BY_STATUS = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "apolice_emitida" },
  { color: "light-blue", status: "aguardando_emissao_minuta" },
  { color: "light-blue", status: "aguardando_analise_minuta" },
  { color: "yellow", status: "em_andamento" }
];
const DEFAULT_STATUS = { color: "yellow" };
const DEFAULT_PROPS = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
export default {
  data: () => ({
    header: TABLE_HEADERS,
    options: defaultFilterOptions(),
    search: "",
    differenceInDays,
    currentTab: 2
  }),
  mixins: [CommonPayload, LoadingRequest],
  created() {
    this.updateOptionsAccordingTabView(this.currentTab);
    this.fetchCriticism(this.getPayload(this.options, this.search));
  },
  computed: {
    ...mapState("quotation", ["itemsCriticism"]),
    defaultConfigs() {
      return {
        ...DEFAULT_PROPS
      };
    }
  },
  methods: {
    ...mapActions("quotation", ["requestItemsCriticism"]),
    fetchCriticism(payload) {
      this.withLoading(this.requestItemsCriticism(payload));
    },
    borderColor(item) {
      const status =
        COLOR_BY_STATUS.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `criticism-table__border-${status.color}`;
    },
    searchByFilter() {
      this.fetchCriticism(this.getPayload(this.options, this.search));
    },
    redirectToCriticism(item) {
      this.saveOptionsDataTable(this.payloadOptions(this.currentTab));
      this.$router.push({
        name: "quotation criticism",
        params: { id: item.cotacao.id }
      });
    },
    formatDate(date) {
      const today = new Date();
      const criticismDate = new Date(date);
      const result = differenceInDays(today, criticismDate);
      const format = `${result} dias`;
      return format;
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13) this.searchByFilter();
    }
  },
  watch: {
    options: {
      handler(value) {
        this.fetchCriticism(this.getPayload(value, this.search));
      },
      deep: true
    }
  }
};
</script>
<style lang="sass">
.criticism-table__
  &border-blue
    border-left: 5px solid #059EE4
  &border-light-blue
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.criticism-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
